<template>
  <div>
    <v-dialog v-model="isOpen" max-width="870">
      <v-card class="lesson-link pb-8">
        <v-card-title primary-title>
          <v-spacer></v-spacer>
          <v-btn outlined small fab @click="closeDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <div class="text-center title-container">
          <h2 class="lesson-link__title">{{ $t('studentInvite') }}</h2>
          <p class="ma-0 ps-2 lessonCreateSubheadline lighten"
          v-html="$t('linkCopySubheadline')"></p>
        </div>
        <div class="lesson-link__inner">
          <div>
            <v-row class="lesson-link__inner--row">
              <v-col cols="8" class="lesson-link__inner--column">
                <v-text-field v-model="copiedLink" outlined
                class="copyLinkTextfield" disabled></v-text-field>
              </v-col>
              <v-col cols="4" class="lesson-link__inner--column">
                <v-snackbar v-model="snackbarShown" :multi-line="false">
                  {{ $t('copiedLink') }}
                  <v-btn color="primary" text @click="hideSnackbar">
                    {{ $t('close').toUpperCase() }}</v-btn>
                </v-snackbar>
                <v-btn
                  color="primary"
                  :loading="isLoading"
                  large
                  depressed
                  rounded
                  block
                  v-clipboard:copy="copiedLink"
                  @click="openSnack"
                >{{ $t('copyLink') }}</v-btn>
              </v-col>
            </v-row>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: ['viewer'],
  data: () => ({
    isOpen: false,
    isLoading: false,
    snackbarShown: false,
    lesson: '',
  }),
  computed: {
    copiedLink() {
      return `${window.location.host}/lesson/${this.lesson}`;
    },
  },
  methods: {
    openDialog(lesson) {
      this.lesson = lesson;
      this.isOpen = true;
    },
    openSnack() {
      this.snackbarShown = true;
      setTimeout(() => {
        this.hideSnackbar();
      }, 3000);
    },
    hideSnackbar() {
      this.snackbarShown = false;
    },
    closeDialog() {
      this.isOpen = false;
    },

    submitForm() {},
  },
};
</script>

<style lang="scss">
.lesson-link {
  &__title {
    padding-bottom: 15px;
  }
  &__inner {
    max-width: 650px;
    margin: 0 auto;

    padding-top: 2vh;
    padding-bottom: 2vh;
    @media (max-width: 1024px) {
      &--row {
        flex-direction: column !important;
      }
      &--column {
        width:100% !important;
        max-width: 100%;
      }
    }
  }
}
</style>
